import {
  NOTIFICATION_EVENTS,
  NotificationStrategy,
  dispatchNotificationEvent,
  markNotificationAsResolved,
} from '../../../../shared/services/notification/workflow';

type NotificationActionItem = Parameters<NotificationStrategy['accept']>[0]['item'];

type FinalizeActionParams = {
  item: NotificationActionItem;
  strategyName: string;
  action: 'accept' | 'reject';
};

export async function finalizeNotificationAction({
  item,
  strategyName,
  action,
}: FinalizeActionParams): Promise<void> {
  if (!item.notificationId) {
    console.error(`[${strategyName}] ${action}:missing notificationMasterId`, {
      item,
    });
    return;
  }

  await markNotificationAsResolved(item.notificationId);

  dispatchNotificationEvent(NOTIFICATION_EVENTS.DATA_REFRESH, {
    notificationId: item.notificationId,
    userNotificationId: item.userNotificationId,
    type: item.type,
    payload: item.payload,
  });
}
